<template>
  <section class="pedido-enviado">
    <div class="container">
      <div class="row" :style="'margin-top: 50px;'">
        <div class="col-12">
          <div class="return d-block d-sm-none">
            <img :src="require('@/assets/img/backspace.svg')" alt="backspace">
          </div>
          <span class="check"><img :src="require('@/assets/img/check.svg')" alt="check"></span>
          <div class="listo">
            <h3>¡Listo!</h3>
            <p>La cuota se creó correctamente!</p>
            <router-link :to="route + 'cuota-listado'" class="btn-yellow">
              Entendido
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {route} from "@/enviroment"

export default {
  name: "ItemCreated",
  props: [
    'message',
    'parent'
  ],
  data() {
    return {
      route: route,
    }
  },
}
</script>